(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var counter = document.getElementById("counter");
anime({
  targets: "#counter",
  innerHTML: [0, counter.getAttribute("data-count")],
  easing: "easeOutExpo",
  round: 1,
  // Ensures no decimals
  duration: 5000,
  // Total animation duration in milliseconds
  update: function update(anim) {
    counter.innerHTML = anim.animations[0].currentValue;
  }
});

},{}]},{},[1]);
